import script from "./BackendProps.vue?vue&type=script&lang=js"
export * from "./BackendProps.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__